import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { API, formatApiErrorDetail } from "@/auth";

function formatDate(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  if (!y || !m || !d) return iso;
  return `${d}-${m}-${y}`;
}

export default function PreviousResults() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  const load = () => {
    setLoading(true);
    axios
      .get(`${API}/admin/results`, { withCredentials: true })
      .then((r) => setRows(r.data))
      .catch(() => toast.error("Failed to load results"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    document.title = "Previous Results | Admin";
    load();
  }, []);

  const remove = async (row) => {
    if (!window.confirm(`Delete result for ${formatDate(row.date)}?`)) return;
    try {
      await axios.delete(`${API}/admin/results/${row.id}`, { withCredentials: true });
      toast.success("Deleted");
      load();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };

  return (
    <div className="ap-card" data-testid="admin-previous-results-page">
      <div className="ap-list-head">
        <h2 className="ap-card-title ap-card-title--center">PREVIOUS RESULTS</h2>
        <Link to="/admin/result" className="ap-btn ap-btn-primary" data-testid="admin-add-result-button">
          + Add Result
        </Link>
      </div>

      <div className="ap-table-scroll">
        <table className="ap-list" data-testid="previous-results-table">
          <thead>
            <tr>
              <th>Sl.No</th>
              <th>Date</th>
              <th>First Round</th>
              <th>Second Round</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr><td colSpan={5} className="ap-list-empty">Loading…</td></tr>
            )}
            {!loading && rows.length === 0 && (
              <tr><td colSpan={5} className="ap-list-empty" data-testid="previous-results-empty">No results yet.</td></tr>
            )}
            {rows.map((row, i) => (
              <tr key={row.id} data-testid={`result-row-${row.id}`}>
                <td>{i + 1}</td>
                <td data-testid={`result-date-${row.id}`}>{formatDate(row.date)}</td>
                <td data-testid={`result-fr-${row.id}`}>{row.first_round || "--"}</td>
                <td data-testid={`result-sr-${row.id}`}>{row.second_round || "--"}</td>
                <td>
                  <button
                    className="ap-icon-btn ap-icon-btn-edit"
                    data-testid={`result-edit-${row.id}`}
                    onClick={() => nav(`/admin/result?id=${row.id}`)}
                  >
                    <Pencil size={14} /> Edit
                  </button>
                  <button
                    className="ap-icon-btn ap-icon-btn-delete"
                    data-testid={`result-delete-${row.id}`}
                    onClick={() => remove(row)}
                  >
                    <Trash2 size={14} /> Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
